<ng-container *ngIf="marketMovesTableData?.cells.length; else riskDataMissing">
	<section class="row">
		<h3 class="col-24 title-main">{{ componentTitle }}</h3>
		<section class="col-24 text-16-bold" dcrHTMLKey="POWERED_BY_ALADDIN">(Powered by Aladdin)</section>
		<section class="col-24 text-16 date" *ngIf="asOfDate">
			<span dcrHTMLKey="AS_OF_DATE_DYNAMIC" [dcrSubstitutions]="{ $asOfDate$: asOfDate }">As of $asOfDate$.</span>
			<span
				*ngIf="enableScenarioAdvisoryFee && customAdvisoryFee"
				dcrHTMLKey="CUSTOM_ADVISORY_FEE_AMOUNT_ENABLED_TEXT_DYNAMIC"
				[dcrSubstitutions]="{ $customAdvisoryFee$: customAdvisoryFee }"
				>Scenario potential impact is net of $customAdvisoryFee$% advisory fee.</span
			>
			<span *ngIf="enableScenarioAdvisoryFee && !customAdvisoryFee" dcrHTMLKey="CUSTOM_ADVISORY_FEE_AMOUNT_DISABLED_TEXT_DYNAMIC"
				>Scenario potential impact is gross of advisory fee.</span
			>
		</section>
		<p class="col-24 disclaimer-container margin-top-10" dcrHTMLKey="RISK_SCENARIO_DISCLAIMER">
			Evaluate your portfolio's sensitivity to different factors and themes. Holdings have been converted to asset classes represented by market indexes, and 12 months of
			income yield are included for fixed income instruments
		</p>
	</section>

	<!-- Buttons above table -->
	<section class="row margin-top-20 align-items-center">
		<div class="col-7 col-md-24 margin-bottom-20">
			<button dz-button color="secondary" (click)="openScenarioSelectionDialog()" dcrHTMLKey="CHANGE_ADD_SCENARIOS" *dcrIf="'SHOW_ST_SCENARIOS_BUTTON'; default: true">
				Change/Add sample scenarios
			</button>
		</div>

		<div class="col-17 col-md-24 d-flex justify-content-right market-moves-buttons margin-bottom-20">
			<div class="padding-right-8" *ngIf="isCustomFeeEnabled && enableScenarioAdvisoryFee">
				<cfe-custom-advisory-fee-dialog-button id="sc-custom-fee-dialog" [customAdvisoryFee]="customAdvisoryFee"> </cfe-custom-advisory-fee-dialog-button>
			</div>
			<!-- Include Yield -->
			<div class="padding-horizontal-15 text-align-right yield-toggle" *dcrIf="'SHOW_ST_YIELD_BUTTON'; default: true">
				<dz-toggle-switch
					class="toggle"
					[toggleOn]="includeYield"
					[toggleLabel]="'Include Yield' | dcr : 'RESULTS_INCLUDE_YIELD_TITLE'"
					[dcrKeys]="['RESULTS_INCLUDE_YIELD_TITLE']"
					(click)="toggleScenarioYield()"
					custom-tracking
					[track-event]="'market-moves:button:include yield:' + (includeYield ? 'off' : 'on')"
				>
				</dz-toggle-switch>
				<icon type="question-circle" class="text-14 info-circle" (click)="isYieldDialogVisible = true" data-link-event="popup:button:why would i include yield"></icon>
				<div class="text-14 yield-subtext" *ngIf="includeYield && !enableScenarioAdvisoryFee" dcrHTMLKey="RESULTS_INCLUDE_YIELD">
					Results include yield in the calculations.
				</div>
			</div>

			<!-- Customize AUM -->
			<div class="padding-horizontal-15 text-align-center customize-aum">
				<button class="options-button" (click)="openCustomizeAmountDialog()" [track-event]="'market-moves:button:customize dollar amount'">
					<icon type="pencil"></icon>
					<span dcrHTMLKey="RESULTS_CUSTOMIZE_DOLLAR_AMOUNT_TITLE">Customize Dollar Amount</span>
				</button>
			</div>

			<!-- Percentage/Dollar Toggle -->
			<div class="padding-left-15 text-align-center results-toggle button-row">
				<button
					class="btn"
					[class.btn-primary]="showDollarAmountAsDefault === false"
					[class.btn-secondary]="showDollarAmountAsDefault === true"
					(click)="updateShowDollarAmount(false)"
					[track-event]="'market-moves:button:toggle result percent'"
				>
					<span class="text-16" dcrHTMLKey="RESULTS_TOGGLE_PERCENT_BUTTON_TEXT1">%</span>
					<span class="text-10" dcrHTMLKey="RESULTS_TOGGLE_PERCENT_BUTTON_TEXT2">$</span>
				</button>
				<button
					class="btn"
					[class.btn-primary]="showDollarAmountAsDefault === true"
					[class.btn-secondary]="showDollarAmountAsDefault === false"
					(click)="updateShowDollarAmount(true)"
					[track-event]="'market-moves:button:toggle result amount'"
				>
					<span class="text-16" dcrHTMLKey="RESULTS_TOGGLE_VALUE_BUTTON_TEXT1">$</span>
					<span class="text-10" dcrHTMLKey="RESULTS_TOGGLE_VALUE_BUTTON_TEXT2">%</span>
				</button>
			</div>
		</div>
	</section>

	<section class="scenario-table grid">
		<!-- Header -->
		<section class="row row-30 text-14-bold col-header-row">
			<span [ngClass]="scenarioNameColumnClass" class="col-header-scenario col-scenario" dcrHTMLKey="SCENARIO_TABLE_HEADER">Scenario</span>
			<section *ngFor="let portfolio of marketMovesTableData.headersX" [ngClass]="scenarioValueColumnClass" class="d-flex col-value justify-content-center text-align-center">
				<div>
					<span>{{ portfolio.formattedValue }}</span>
					<div class="text-11 secondary-value">
						<span class="margin-right-3" dcrHTMLKey="RESULTS_DOLLAR_AMOUNT">Dollar Amount:</span>
						{{ defaultAumValue | currency : 'USD' : 'symbol-narrow' : '.0-0' }}
					</div>
				</div>
			</section>
		</section>
		<!-- Main table -->
		<section class="row row-30 text-16 text-md-14 yield-row align-items-center" *ngIf="includeYield">
			<!-- Include Yield Title -->
			<span *ngIf="yieldTableData; else noYieldTitle" [ngClass]="scenarioNameColumnClass" class="col-scenario text-bold">
				{{ yieldTableData.headersY[0].formattedValue }}
				<icon
					type="info-circle"
					class="info-circle text-14 color-primary"
					[tooltip]="yieldInfoBubble"
					[analytic-data]="{ linkName: 'tooltip_' + yieldTableData.headersY[0].rawValue }"
				>
					<ng-template #yieldInfoBubble> <section [innerHTML]="yieldTableData.headersY[0].attribute.infoBubble"></section> </ng-template>
				</icon>
			</span>
			<!-- No Yield Title-->
			<ng-template #noYieldTitle>
				<span [ngClass]="scenarioNameColumnClass" class="col-scenario">
					{{ yieldTitle }}
					<icon
						type="info-circle"
						class="info-circle text-14 color-primary"
						[tooltip]="noYieldInfoBubble"
						[analytic-data]="{ linkName: 'tooltip_twelveMonthTrailingYield' }"
					>
						<ng-template #noYieldInfoBubble> <section [innerHTML]="yieldInfo"></section> </ng-template>
					</icon>
				</span>
			</ng-template>
			<!-- Yield data (percentage Vs Dollar Amount) -->
			<section
				[ngClass]="scenarioValueColumnClass"
				class="mobile-bordered col-portfolios col-value text-16 text-md-14 text-sm-12 text-bold text-align-right"
				*ngFor="let portfolio of marketMovesTableData.headersX; index as portfolioIndex"
			>
				<ng-container *ngIf="yieldTableData; else noYieldData">
					<div class="padding-10 text-align-right" *ngIf="!showDollarAmountAsDefault">
						<span>{{ yieldTableData.cells[0][portfolioIndex].formattedValue }}</span>
						<dcr-cell-content [cell]="yieldTableData.cells[0][portfolioIndex]"></dcr-cell-content>
						<div class="text-11 secondary-value">{{ formatDollarValueCellData(yieldTableData.cells[0][portfolioIndex].rawValue, false) }}</div>
					</div>
					<div class="padding-10 text-align-right" *ngIf="showDollarAmountAsDefault">
						<span>{{ formatDollarValueCellData(yieldTableData.cells[0][portfolioIndex].rawValue, false) }}</span>
						<dcr-cell-content [cell]="yieldTableData.cells[0][portfolioIndex]"></dcr-cell-content>
						<div class="text-11 secondary-value">{{ yieldTableData.cells[0][portfolioIndex].formattedValue }}</div>
					</div>
				</ng-container>
				<ng-template #noYieldData>
					<div class="d-flex padding-10 text-align-right">{{ dashValue }}</div>
				</ng-template>
			</section>
		</section>

		<ng-container *ngFor="let category of scenarioCategories">
			<div *ngIf="categorisedSelectedScenarios[category] && categorisedSelectedScenarios[category].length">
				<section class="row align-items-center" *ngIf="categorisedSelectedScenarios[category].length > 0">
					<!-- Category and Scenario names (first column) -->
					<section [ngClass]="scenarioNameColumnClass" class="col-scenario">
						<div class="category-header">
							<img ada-decorative class="category-image" [src]="getImagePath(category)" onerror="this.style.display = 'none'" />
							<div class="category-contents">
								<h4 class="text-12 category-name secondary-value">
									{{ getCategoryName(category) }}
								</h4>
								<div *ngFor="let scenario of categorisedSelectedScenarios[category]" class="category-scenarios padding-vertical-10">
									<span class="text-16 text-md-14 text-sm-12">
										{{ scenario.formattedValue }}
									</span>
									<icon
										type="info-circle"
										class="info-circle text-14 color-primary"
										[tooltip]="infoBubble"
										[analytic-data]="{ linkName: 'tooltip_' + scenario.formattedValue }"
									>
									</icon>
									<dcr-cell-content [cell]="scenario"></dcr-cell-content>
									<ng-template #infoBubble> <section [innerHTML]="scenario.attribute.infoBubble"></section> </ng-template>
								</div>
							</div>
						</div>
					</section>

					<!-- Scenario values for each portfolio column -->
					<section
						[ngClass]="scenarioValueColumnClass"
						class="mobile-bordered col-value text-16 text-md-14 text-sm-12 text-bold"
						*ngFor="let portfolio of marketMovesTableData.headersX; index as portfolioIndex"
					>
						<div class="padding-top-40 padding-bottom-15 col-portfolios">
							<h4 class="text-12 category-name secondary-value"></h4>
							<ng-container *ngFor="let scenario of categorisedSelectedScenarios[category]">
								<ng-container *ngTemplateOutlet="cellData; context: { $implicit: getMarketMovesTableData(scenario, portfolioIndex) }"></ng-container>
								<ng-template #cellData let-data>
									<div
										*ngIf="!showDollarAmountAsDefault"
										class="padding-10 text-align-right"
										[class.positive-value]="data > 0"
										[class.negative-value]="data <= 0"
									>
										{{ formatCellData(data) }}
										<div class="text-11 secondary-value">{{ formatDollarValueCellData(data) }}</div>
									</div>
									<div *ngIf="showDollarAmountAsDefault" class="padding-10 text-align-right" [class.positive-value]="data > 0" [class.negative-value]="data <= 0">
										{{ formatDollarValueCellData(data) }}
										<div class="text-11 secondary-value">{{ formatCellData(data) }}</div>
									</div>
								</ng-template>
							</ng-container>
						</div>
					</section>
				</section>
			</div>
		</ng-container>
	</section>

	<section class="row row-30">
		<ng-container *ngIf="!containsTransitionPortfolio && showScenarioTesterLink">
			<section *showOnlyInView="[ViewCategory.FA_SELF_SERVICE, ViewCategory.PROPOSAL]" class="col-24 margin-standard">
				<div *dcrIf="'SHOW_ST_RUN_BUTTON'; default: true">
					<button
						dz-button
						color="secondary"
						*ngIf="this.selectedScenarios && this.selectedScenarios.length"
						(click)="goToScenarioTesterURL()"
						dcrHTMLKey="SCENARIO_TESTER_LINK"
						custom-tracking
						track-event="scenariotester:Test against 30+ risks"
					>
						Test Against 30+ Risks
					</button>
				</div>
			</section>
		</ng-container>
		<div class="col-24">
			<ac-disclosure [isExpandable]="false">
				<ac-tpm-disclosure></ac-tpm-disclosure>
				<span *ngIf="!includeYield" [innerHTML]="'SCENARIO_TESTER_DISCLAIMER' | dcr : 'SCENARIO_TESTER_DISCLAIMER'"></span>
				<span *ngIf="includeYield" [innerHTML]="'SCENARIO_TESTER_DISCLAIMER_WITH_YIELD' | dcr : 'SCENARIO_TESTER_DISCLAIMER_WITH_YIELD'"></span>
			</ac-disclosure>
		</div>
	</section>
	<bfa-modal width="1050px" [enableBackdrop]="true" [enableClose]="true" [(isVisible)]="isYieldDialogVisible">
		<div class="ac-modal yield-modal">
			<div class="header"><h3 class="text-align-center" dcrHTMLKey="WHY_INCLUDE_YIELD">Why would I include yield?</h3></div>
			<div class="content"><div class="subheader-content" dcrHTMLKey="WHY_INCLUDE_YIELD_CONTENT">WHY_INCLUDE_YIELD_CONTENT</div></div>
		</div>
	</bfa-modal>
</ng-container>

<ng-template #riskDataMissing>
	<section>
		<icon class="warning-icon" type="exclamation-triangle"></icon>
		<span [innerHTML]="'Risk data for your portfolio(s) is missing. Please reload the page.' | dcr : 'RISK_DATA_MISSING'"></span>
	</section>
</ng-template>
